import { CLEARANCE_ERROR_MAPPINGS, OEMS } from '../constants';
import { Oem } from '@/types';

export const getClearanceNotes = (oemDisplayName: string, errorCode?: string | null): string => {
  if (!errorCode) {
    return '';
  }

  const oemEntry = Object.entries(OEMS).find((entry) => entry[1].name === oemDisplayName);

  if (oemEntry) {
    const oemKey = oemEntry[0] as Oem;
    const oemErrors = CLEARANCE_ERROR_MAPPINGS[oemKey];

    if (oemErrors && oemErrors[errorCode]) {
      return oemErrors[errorCode];
    }
  }

  return '';
};
